import React from 'react';
import {checkStatusChange} from '../utils/statuses';
import {Record} from '../../../../../../stores/Form/Record';
import {
    ListItemWrapper,
    CreationStatus,
    ChangedStatus,
    AssigneeChange,
    StatusMultipleChanges
} from './ListComponents';
import {ChangeType} from './enums';

type StatusItemProps = {
    statuses: Record[];
    idx: number;
    shouldFetchMore: boolean;
    statusColorMap: {
        statdes: string;
        color: string;
    }[];
    isLegacyStore: boolean;
    enabledCols: string[];
};

export const StatusItem = ({
    statuses,
    idx,
    shouldFetchMore,
    statusColorMap,
    isLegacyStore,
    enabledCols
}: StatusItemProps) => {
    const status = checkStatusChange(statuses, idx, shouldFetchMore, statusColorMap);
    let children;
    switch (status?.type) {
        case ChangeType.Created:
            children = CreationStatus(status, isLegacyStore);
            break;
        case ChangeType.Status:
            children = ChangedStatus(status, isLegacyStore);
            break;
        case ChangeType.Assign:
            children = AssigneeChange(status, isLegacyStore);
            break;
        case ChangeType.Multiple:
            children = StatusMultipleChanges(status, isLegacyStore);
            break;
        default:
            return null;
    }
    return children ? (
        <ListItemWrapper
            status={status}
            record={statuses[idx]}
            enabledCols={enabledCols}
            children={children}
        />
    ) : null;
};
